"use client";
import { m as motion } from "framer-motion";
import { ArrowRight, Zap } from "lucide-react";
import { EXTERNAL_LINKS } from "../lib/constants";

export const CallToActionSection = () => {
  return (
    <section className="relative container-class overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-mesh opacity-50 pointer-events-none" />
      
      <div className="section-inner relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
          className="relative glass-card p-12 md:p-16 text-center overflow-hidden"
        >
          {/* Decorative Blobs */}
          <div className="absolute top-0 left-1/4 w-64 h-64 bg-gradient-radial-primary opacity-20 blur-3xl" />
          <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-gradient-radial-secondary opacity-20 blur-3xl" />
          
          <div className="relative z-10 space-y-8">
            {/* Icon Badge */}
            <motion.div
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/10 border-2 border-primary/20"
            >
              <Zap className="w-8 h-8 text-primary" fill="currentColor" />
            </motion.div>

            {/* Heading */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
                HR leaders who can speak AI are{" "}
                <span className="gradient-text">getting a seat at the table.</span>
              </h2>
            </motion.div>

            {/* Subtext */}
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-xl md:text-2xl text-foreground/80 max-w-2xl mx-auto"
            >
              Build that fluency in 90 days — with a cohort of peers doing the same.
            </motion.p>

            {/* CTA Button */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="pt-4"
            >
              <a
                href={EXTERNAL_LINKS.PREMIUM_MASTERMIND_APPLICATION}
                className="group inline-flex items-center gap-3 px-10 py-5 text-lg font-semibold rounded-2xl bg-secondary text-secondary-foreground shadow-secondary hover:shadow-glow-secondary transition-all duration-300 hover:-translate-y-1"
              >
                Apply for Your Spot
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
              </a>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
